import useGetBookByRedeemCode from './useGetBookByRedeemCode';

export default useGetBookByRedeemCode;
